import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionService } from '../../services/subscription.service';
import { SubscriptionFeatures, SubscriptionStatus, SubscriptionUsage } from '../../models/subscription-usage.model';
import { CurrentUserService } from 'src/app/services/current-user.service';

@Component({
    selector: 'app-subscription-plan-details',
    templateUrl: './subscription-plan-details.component.html',
    styleUrls: ['./subscription-plan-details.component.scss'],
    standalone: false
})
export class SubscriptionPlanDetailsComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal,
    private subscriptionService: SubscriptionService,
    private currentUserService: CurrentUserService,
    private cdr: ChangeDetectorRef
  ) { }
  userId: any
  currentPlanUsageDetails: any
  subscription_features: SubscriptionFeatures | null = null;
  usage: SubscriptionUsage | null = null;
  page: boolean = false
  ngOnInit(): void {
    if (this.userId) {
      this.getCurrentPlanUsage()
    }
    else {
      this.page = true
      this.setUpCurrentUser()
    }
  }

  setUpCurrentUser() {
    this.currentUserService.currentUser.subscribe((res: any) => {
      if (res) {
        this.userId = res.id
        this.getCurrentPlanUsage()
      }
    
          this.cdr.detectChanges();})
  }

  closeModal() {
    this.activeModal.close('dismissed');
  }

  getCurrentPlanUsage() {
    this.subscriptionService.getSubscriptionByIdForUsage(this.userId).subscribe((res: SubscriptionStatus) => {
      if (res) {
        this.subscription_features = res.subscription_features
        this.usage = res.usage;
        this.cdr.detectChanges();
      }
    })
  }

}
